import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { OsnovZaPlacenoOdsustvo } from './osnov-za-placeno-odsustvo';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';




@Component({
  selector: 'yt-osnov-za-placeno-odsustvo-update',
  templateUrl: './osnov-za-placeno-odsustvo-update.component.html'
})
export class OsnovZaPlacenoOdsustvoUpdateComponent 
extends BaseUpdateComponent<OsnovZaPlacenoOdsustvo> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Naziv', Validators.required, 'required', 'OSNOVZAPLACENOODSUSTVO.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('Naziv', Validators.maxLength(100), 'maxlength', 'Naziv je obavezan');
    this.addValidatorToFc('min_broj_dana', Validators.required, 'required', 'OSNOVZAPLACENOODSUSTVO.NAZIV.VALIDATION.REQUIRED');

  }

}
